import React from 'react';

const DescriptionManager = () => (
  <div className="admin-screen">
    <h1>Description Manager</h1>
    <p>Manage product details and technical descriptions.</p>
  </div>
);

export default DescriptionManager;
